import { Actions } from 'vuex-smart-module';
import { DataPilotService } from '../../../../services';
import ProductGetters from './getters';
import ProductMutations from './mutations';
import { ProductState } from './state';

const dataPilotService = new DataPilotService();

export default class ProductActions extends Actions<
  ProductState,
  ProductGetters,
  ProductMutations,
  // eslint-disable-next-line no-use-before-define
  ProductActions
> {
  async get_products() {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;

      const payload = {
        filters: this.state.filters,
        filters_exist: true,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING(true);
      const { data, meta } = await dataPilotService.get_products(payload);

      this.mutations.SET_PRODUCTS(data.items);
      this.mutations.SET_EVENTS(data.filters.events);

      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_LOADING(false);
    }
  }
}
